import { api_v2 } from "@/api/axios.config"
import { FavoriteGroup } from "@/types/networking"

const BASE = "/plataforma/favorites"

export const getFavoriteGroups = async (): Promise<FavoriteGroup[]> => {
  const { data } = await api_v2.get(BASE)
  return data
}

export const createFavoriteGroup = async (
  group: Partial<FavoriteGroup>
): Promise<FavoriteGroup> => {
  const { data } = await api_v2.post(BASE, group)
  return data
}

export const updateFavoriteGroup = async (
  groupId: number,
  group: Partial<FavoriteGroup>
): Promise<FavoriteGroup> => {
  const { data } = await api_v2.put(`${BASE}/${groupId}`, group)
  return data
}

export const deleteFavoriteGroup = async (groupId: number): Promise<void> => {
  await api_v2.delete(`${BASE}/${groupId}`)
}

export const addPersonToFavoriteGroup = async (
  groupId: number,
  personUid: string
): Promise<void> => {
  await api_v2.post(`${BASE}/${groupId}/person`, { uid: personUid })
}

export const removePersonFromFavoriteGroup = async (
  groupId: number,
  personUid: string
): Promise<void> => {
  await api_v2.delete(`${BASE}/${groupId}/person/${personUid}`)
}
